import { toast } from "sonner";
import { formatPickupWindowLabel, pickupWindowEndLabel } from "./formatPickupWindowLabel";

const recent = new Map();

export function isAcceptanceProposalOpen(order) {
  if (String(order?.acceptanceTimeProposalStatus || "") !== "proposed") return false;
  const exp = order?.acceptanceTimeProposalExpiresAt;
  if (!exp) return true;
  const ms = new Date(exp).getTime();
  return Number.isFinite(ms) && ms > Date.now();
}

export function acceptanceProposalLabel(order) {
  if (String(order?.orderType || "").toUpperCase() === "DELIVERY" && order?.proposedAcceptanceDeliveryAt) {
    const d = new Date(order.proposedAcceptanceDeliveryAt);
    if (Number.isFinite(d.getTime())) return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
  }
  const windowLabel = String(order?.proposedAcceptancePickupWindow || "").trim();
  if (String(order?.orderType || "").toUpperCase() === "DRIVE") {
    return pickupWindowEndLabel(windowLabel) || formatPickupWindowLabel(windowLabel);
  }
  return formatPickupWindowLabel(windowLabel) || windowLabel;
}

/** One visible notice when the restaurant proposes another time on a manual-accept order. */
export function notifyCustomerTimeProposal(detail = {}) {
  const type = String(detail.type || "");
  const status = String(detail.acceptanceTimeProposalStatus || "");
  if (type !== "acceptance_time_proposed" && status !== "proposed") return;
  const orderId = String(detail.orderId || "").trim();
  const body = String(detail.body || "").trim();
  const proposed = String(detail.proposedAcceptancePickupWindow || "").trim();
  if (!orderId || (!body && !proposed)) return;

  const key = `${orderId}|${proposed || body}`;
  const now = Date.now();
  if (now - (recent.get(key) || 0) < 20000) return;
  recent.set(key, now);

  const shop = String(detail.restaurantName || "Le restaurant").trim() || "Le restaurant";
  toast.message(detail.title || "Nouvelle heure proposée", {
    description: body || `${shop} propose ${formatPickupWindowLabel(proposed) || "une autre heure"}.`,
    duration: 12000,
  });
}
